<template>
  <transition
    @enter="enter"
    @after-enter="afterEnter"
    @before-leave="beforeLeave"
    @leave="leave">

    <aside 
      v-show="visible"
      :class="classes">

      <!-- Header -->
      <header class="n-burger__header">
        <button 
          class="n-burger__close"
          @click="close">
          <span></span>
          <span></span>
        </button>

        <img :src="logo" alt="Logo" class="n-burger__logo">
      </header>

      <!-- Body -->
      <div class="n-burger__body">
        <ul class="n-burger__list">
          <!-- Menu -->
          <li class="n-burger__item">
            <router-link
              :to="{ name: 'sayl-oat-catalog.catalog' }"
              class="n-burger__link n-header__burger-bag">
              {{ $t('sayl-oat.burger_menu') }}
            </router-link>
          </li>

          <!-- Cart -->
          <li class="n-burger__item">
            <router-link
              :to="{ name: 'sayl-oat-checkout.cart' }"
              class="n-burger__link n-header__burger-bag">
              {{ $t('sayl-oat.burger_your_cart') }}
              <checkout-cart-badge />
            </router-link>
          </li>

          <!-- Admin actions -->
          <li
            v-for="item in admin"
            :key="item.label" 
            class="n-burger__item">
            <actions-button
              appearance="subtle" 
              class="n-burger__link"
              @click="onShowAdminPin">{{ item.label }}</actions-button>
          </li>

          <!-- Other actions -->
          <!-- <li
            v-if="false"
            v-for="item in actions"
            :key="item.label" 
            class="n-burger__item">
            <router-link 
              class="n-burger__link"
              :to="item.href">{{ item.label }}</router-link>
          </li> -->
        </ul>
      </div>

      <!-- Footer -->
      <footer class="n-burger__footer">
        <ul class="n-burger__legal">
          <li
            v-for="item in legal"
            :key="item.label" 
            class="n-burger__legalitem">
            <router-link 
              class="n-burger__legallink"
              :to="item.href">{{ item.label }}</router-link>
          </li>
        </ul>

        <forms-select 
          :placeholder="$t('sayl-oat.burger_lang_placeholder')"
          :options="langs"
          :value="userLang"
          @change="onChangeLang"
        />
      </footer>

      <!-- Blanket -->
      <popins-blanket
        ref="blanket"
        :disabled="false"
        @click="close"
        :visible="visible" />

      <!-- Admin login popin -->
      <popins-modal 
        :klass="{ 'popin-login': true, 'layout-modal': true }"
        @close="onHideAdminPin" 
        :visible="showAdminModal">
        
        <template v-slot:header>
          <h1 class="layout-modal__title">Restricted area</h1>
        </template>

        <forms-input 
          autofocus
          :placeholder="$t('sayl-oat.admin_pin_placeholder')"
          v-model="adminPin"
          @input="onGoToAdmin"
        >{{$t('sayl-oat.admin_pin')}}</forms-input>

        <forms-label 
          class="mb-xl"
          v-if="!hasTable"
          intent="danger"
          >{{ $t('sayl-oat.table_not_set')}}</forms-label>
      </popins-modal>
    </aside>
  </transition>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import CheckoutCartBadge from '@/components/checkout/cart-badge'

import LayoutModal from '../layouts/modal'

export default {
  name: 'OATBurger',

  components: {
    CheckoutCartBadge,
    LayoutModal,
  },

  data(){
    return {
      actions: [
        { label: this.$t('sayl-oat.burder_actions_login'), href: {name:'sayl-oat-catalog.catalog'} },
        { label: this.$t('sayl-oat.burger_actions_my_orders'), href: {name:'sayl-oat-catalog.catalog'} },
      ],

      admin: [
        {label: this.$t('sayl-oat.burger_actions_admin'), href: {name:'sayl-oat-admin.admin'} },
      ],

      legal: [
        { label: this.$t('sayl-oat.burger_legal_term_and_conditions'), href: {name:'sayl-oat-cms.terms'} },
        { label: this.$t('sayl-oat.burger_legal_privacy_policy'), href: {name:'sayl-oat-cms.privacy'} },
        { label: this.$t('sayl-oat.burger_legal_cookie_policy'), href: {name:'sayl-oat-cms.cookie'} },
      ],

      showAdminModal: true,
      adminPin: null
    }
  },

  computed: {
    ...mapState({
      cart: state => state['sayl-oat'].cart,
      shop: state => state['sayl-oat'].shop,
      visible: state => state.bootstrap.burger,
      locales: state => state.bootstrap.i18n.locales,
      i18n: state => state.bootstrap.i18n,
      user: state => state['sayl-oat.user'].user,
      services: state => state['sayl-oat.user'].services
    }),

    classes(){
      return {
        'n-burger': true,
        // '-is-active': this.active === true
        '-is-active': true
      }
    },

    hasTable() {
      return !['', null, undefined].includes(this.cart.tableNumber);
    },

    langs() {
      return this.locales.map((l) => {
        return {
          label: this.$t(`sayl-oat.lang_${l.toISO3166().toLowerCase()}`), 
          value: l.toISO639()
        } 
      });
    },

    logo(){
      return this.shop && this.shop.logo ? this.shop.logo : null;
    },

    servicesList() {
      return this.services.map(service => {
        return {
          label: this.$t(`sayl-oat.service_${service}`),
          value: service
        };
      });
    },

    userLang() {
      return this.user !== null ? this.user.lang : null;
    },
  },

  watch: {
    burger(value){
      value ? this.show() : this.hide();
    },
    'cart.tableNumber': {
      immediate: true,
      handler(value) {
        const t = localStorage.getItem('table');
        if(['', null, undefined].includes(t)) {
          this.onShowAdminPin();
        } else {
          this.showAdminModal = false;
        }
      }
    }
  },

  methods: {
    ...mapActions({
      changeLang: 'sayl-oat.user/changeLang'
    }),

    close(){
      this.$store.dispatch('bootstrap/burger', false);
    },

    // 
    // Transitions
    // 

    afterEnter(el){
      this.active = true;
    },

    beforeLeave(el){
      this.active = false;
    },

    delay(delay) {
      return new Promise(function(resolve) {
        setTimeout(resolve, delay);
      });
    },

    enter(el, done){
      this.delay(500).then(() => { done() });
    },

    leave(el, done){
      this.delay(500).then(() => { done() });
    },

    show(){
      document.body.classList.add('-no-scroll');
    },

    hide(){
      document.body.classList.remove('-no-scroll');
    },

    onChangeLang(value) {
      const lang = this.locales.find(l => {
        return l.toISO639() === value;
      });
      this.changeLang(lang.toISO3166()).then(() => { 
        this.i18n.setLocale(lang.toISO3166());
      });
    },

    onHideAdminPin() {
      if(this.hasTable) {
        this.showAdminModal = false;
      }
    },

    onShowAdminPin() {
      if(this.$route.name !== 'sayl-oat-admin.admin') {
        this.close();
        this.showAdminModal = true;
      }
    },

    onGoToAdmin() {
      if(this.adminPin === "1020") {
        this.adminPin = null;
        localStorage.setItem('admin', true);
        this.showAdminModal = false;
        this.$router.push({name: 'sayl-oat-admin.admin'});
      }
    }
  },
}
</script>
